var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from 'react';
function doObjectsMatch(obj1, obj2) {
  if (obj1 == obj2) return true;
  if (!obj1 || !obj2) return false;
  var keys1 = __spreadArray([], __read(new Set(Object.keys(obj1))), false);
  var keys2 = __spreadArray([], __read(new Set(Object.keys(obj2))), false);
  if (keys1.length != keys2.length) return false;
  for (var i = 0; i < keys1.length; i++) {
    var key = keys1[i];
    if (keys2.indexOf(key) === -1) return false;
    if (obj1[key] !== obj2[key]) return false;
  }
  return true;
}
function writeOutput(label, fields) {
  console.group(label);
  Object.keys(fields).forEach(function (key) {
    //Do not try to convert the value into an object.
    //In some cases, the value is a string representation
    //of an ESI object and that representation may not be
    //valid JSON.
    console.log(key, fields[key]);
  });
  console.groupEnd();
}
export function EsiContextCsr(props) {
  var _a = __read(useState(), 2),
    fields = _a[0],
    setFields = _a[1];
  useEffect(function () {
    if (doObjectsMatch(props === null || props === void 0 ? void 0 : props.fields, fields)) return;
    setFields(props === null || props === void 0 ? void 0 : props.fields);
  }, [props]);
  useEffect(function () {
    if (!fields) return;
    writeOutput("Uniform ESI context (CSR)", fields);
  }, [fields]);
  return null;
}
export function EsiContextSsr(props) {
  var _a = __read(useState(), 2),
    fields = _a[0],
    setFields = _a[1];
  useEffect(function () {
    if (doObjectsMatch(props === null || props === void 0 ? void 0 : props.fields, fields)) return;
    setFields(props === null || props === void 0 ? void 0 : props.fields);
  }, [props]);
  useEffect(function () {
    if (!fields) return;
    writeOutput("Uniform ESI context (SSR)", fields);
  }, [fields]);
  return null;
}